var chunkToChildrenMap = {
	"87267": [
		98381,
		36482,
		54758,
		25653,
		75711,
		18705,
		9105
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}, () => {

}));